import CryptoJS from 'crypto-js';

const SECRET_KEY = 'TTEXVcTMCng3eetYKBmnVVeBtQ77217Z';
const IV_ARRAY = [
    0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
    0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00
];

/**
 * Byte 배열을 Hex 문자열로 변환
 */
function bytesToHex(bytes: number[]): string {
    return bytes.map(b => {
        const hex = b.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    }).join('');
}


/**
 * AES-256-CBC 암호화 (Java 백엔드와 호환)
 */
export function encryptAES(plainText: string): string {
    try {
        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);

        // ⭐ Byte 배열 → Hex 문자열 → WordArray
        const ivHex = bytesToHex(IV_ARRAY);
        console.log('[DEBUG] IV Hex:', ivHex); // "01000000000000000000000000010000"
        const iv = CryptoJS.enc.Hex.parse(ivHex);

        const encrypted = CryptoJS.AES.encrypt(plainText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.toString();
    } catch (error) {
        console.error('Encryption error:', error);
        throw new Error('암호화 실패');
    }
}

/**
 * AES-256-CBC 복호화
 */
export function decryptAES(encryptedText: string): string {
    try {
        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
        const ivHex = bytesToHex(IV_ARRAY);
        const iv = CryptoJS.enc.Hex.parse(ivHex);

        console.log('[CRYPTO] 복호화 시작');
        console.log('[CRYPTO] 암호화된 텍스트:', encryptedText.substring(0, 50) + '...');

        const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const result = decrypted.toString(CryptoJS.enc.Utf8);

        if (!result) {
            throw new Error('복호화 결과가 비어있습니다.');
        }

        console.log('[CRYPTO] 복호화 완료:', result.substring(0, 800));
        return result;
    } catch (error) {
        console.error('[CRYPTO] 복호화 실패:', error);
        throw new Error('복호화에 실패했습니다.');
    }
}

export function encryptHeader(value: string): string {
    return encryptAES(value);
}

export const CRYPTO_HEADERS = {
    ENABLED: '+RWJ53Z56g+766YSDd5XbA==',
    DISABLED: '3YLmndhFNrefaa+D3Uqplw==',
};